<template>
  <v-container
    class="container"
    fluid
    grid-list-md
  >
    <v-flex xs12>
      <v-card>
        <v-card-title
        class="pb-0">
          <div class="title">All Advertisers</div>
          <v-spacer/>
          <v-btn
            color="primary"
            @click="openNewDialog"
          >
            <v-icon left dark>add</v-icon>
            Add new
          </v-btn>
        </v-card-title>
        <v-card-title class="pt-0">
          <v-flex
            xs8
            sm4
            md3
            lg2>
            <v-select
              :items="items"
              v-model="selectedItem"
              single-line
              hide-details
              item-text="name"
              item-value="value"
            />
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="filteredClients"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td
                v-for="(header, index) in headers"
                :key="index"
                :class="header.class"
                @click="editClient(props.item.id)"
              >
                {{ header.formatter(props.item[header.value]) }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
  import {identityFormatter, accountTypeFormatter} from '../../helpers/table-formatters'
  export default {
    name: 'AdminClientsTable',
    data () {
      return {
        headers: [
          {
            text: 'Name',
            align: 'left',
            class: 'text-xs-left',
            sortable: false,
            value: 'name',
            formatter: identityFormatter
          },
          {
            text: 'Account Type',
            align: 'left',
            class: 'text-xs-left',
            sortable: false,
            value: 'type',
            formatter: accountTypeFormatter
          },
          {
            text: 'Account Status',
            align: 'left',
            class: 'text-xs-left',
            sortable: false,
            value: 'status',
            formatter: identityFormatter
          },
          {
            text: 'Location',
            align: 'left',
            class: 'text-xs-left',
            sortable: false,
            value: 'location',
            formatter: identityFormatter
          }
        ],
        items: [
          {
            name: 'Active Only',
            value: 'Active'
          },
          {
            name: 'Inactive',
            value: 'Inactive'
          },
          {
            name: 'All',
            value: null
          }
        ],
        selectedItem: 'Active'
      }
    },
    props: {
      clients: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      filteredClients () {
        if (!this.selectedItem) return this.clients
        return this.clients.filter(client => client.status === this.selectedItem)
      }
    },
    methods: {
      openNewDialog () {
        this.$router.push({name: 'NewAdvertiser'})
      },
      editClient (id) {
        this.$emit('setEditedClient', id)
      }
    }
  }
</script>
